import type { AppRouterOutputs } from '@alison/api/router';
import type { Outcome } from '../outcomes/outcomes.js';

export const ACTIVITY_LIMIT = 5;

export const STATUS_PILL: Record<ActivityStatus, string> = {
  running: 'Running',
  failed: 'Failed',
  awaiting_decision: 'Needs decision',
};

export type ActivitySession = AppRouterOutputs['workflows']['sessionList']['sessions'][number];

export type ActivityStatus = 'running' | 'failed' | 'awaiting_decision';

export type ActivityRow =
  | { kind: 'session'; key: string; at: string; status: ActivityStatus; session: ActivitySession }
  | { kind: 'completed'; key: string; at: string; outcome: Outcome };

function isActivityStatus(status: string): status is ActivityStatus {
  return status in STATUS_PILL;
}

export function activityRows(
  sessions: ActivitySession[],
  outcomes: Outcome[],
  limit: number = ACTIVITY_LIMIT,
): ActivityRow[] {
  const sessionRows: ActivityRow[] = sessions.flatMap((session) =>
    isActivityStatus(session.status)
      ? [
          {
            kind: 'session',
            key: `session:${session.rootRunId}`,
            at: session.updatedAt,
            status: session.status,
            session,
          },
        ]
      : [],
  );
  const shownRoots = new Set(
    sessionRows.flatMap((row) => (row.kind === 'session' ? [row.session.rootRunId] : [])),
  );
  const completed: ActivityRow[] = outcomes
    .filter((outcome) => !shownRoots.has(outcome.sessionId))
    .map((outcome) => ({
      kind: 'completed',
      key: `completed:${outcome.runId}`,
      at: outcome.completedAt,
      outcome,
    }));
  return [...sessionRows, ...completed]
    .sort((left, right) => Date.parse(right.at) - Date.parse(left.at))
    .slice(0, limit);
}
